import { WizardStep } from "@/components/organisms";
import { fakeI18n } from "@/i18n";

import { AddressStep, ContactStep, FinancialStep, GeneralStep, IntroStep, SummaryStep } from "./steps";
import {
    formSchemaAddresses,
    formSchemaContact,
    formSchemaFinancialStep,
    formSchemaGeneralStep,
} from "./steps/formSchema";

export enum StepId {
    Intro = 0,
    General = 1,
    Address = 2,
    Contact = 3,
    FinancialTax = 4,
    Summary = 5,
}

export const CompanySteps: WizardStep[] = [
    {
        stepId: StepId.Intro,
        stepBarId: StepId.Intro,
        title: fakeI18n.t("Common.Introduction"),
        component: IntroStep,
    },
    {
        stepId: StepId.General,
        stepBarId: StepId.General,
        title: fakeI18n.t("Common.General"),
        component: GeneralStep,
        schema: formSchemaGeneralStep,
    },
    {
        stepId: StepId.Address,
        stepBarId: StepId.Address,
        title: fakeI18n.t("Common.Address"),
        component: AddressStep,
        schema: formSchemaAddresses,
    },
    {
        stepId: StepId.Contact,
        stepBarId: StepId.Contact,
        title: fakeI18n.t("Common.Contact"),
        component: ContactStep,
        schema: formSchemaContact,
    },
    {
        stepId: StepId.FinancialTax,
        stepBarId: StepId.FinancialTax,
        title: fakeI18n.t("Common.FinancialTax"),
        component: FinancialStep,
        schema: formSchemaFinancialStep,
    },
    {
        stepId: StepId.Summary,
        stepBarId: StepId.Summary,
        title: fakeI18n.t("Common.Summary"),
        component: SummaryStep,
    },
];
